import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import cmsPageAPI from "../../api/cmsPageApi";
import SEO from "../../components/SEO";
import Breadcrump from "../../components/Breadcrump";

function TermsofServices() {
  const location = useLocation();
  const path = location.pathname.split("/")[1];

  const [metaData, setMetaData] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, [path]);

  const fetchCMSDetails = async () => {
    try {
      const res = await cmsPageAPI.details(path);

      if (res.code === 200) {
        const result = res.data;

        setTitle(result.title);
        setDescription(result.content);
        setMetaData(result?.meta);
      }
    } catch (err) {}
  };

  return (
    <>
       <div className="min-h-screen bg-[var(--color-bg)] text-[var(--color-text)] font-[family-name:var(--font-body)] overflow-x-hidden transition-all duration-300">
      {/* SEO & Breadcrumbs */}
      <SEO meta={metaData} />
      <Breadcrump title={title} />

      {/* Main Content Section */}
      <section className="py-12 md:py-20 px-2 sm:px-6 lg:px-8 relative">


        {/* Changed max-w-4xl to max-w-6xl for increased card width */}
        <div className="max-w-6xl mx-auto relative z-10">

          {/* Content Card with Smooth Slide Animation */}
          <div className="bg-[var(--color-white)] p-6  lg:p-10  xl:p-12 sm:p-10 md:p-12 rounded-[var(--radius-lg)] shadow-[var(--shadow-md)] border border-[var(--color-border)] transition-all duration-300 hover:shadow-[var(--shadow-lg)] animate-[fadeInUp_1s_ease-out]">
            <div 
              dangerouslySetInnerHTML={{ __html: description }} 
              className="custom-ax-pakhis-about prose prose-lg max-w-none text-[var(--color-text)] leading-[var(--line-height-normal)] space-y-4 [&>h2]:text-[var(--color-primary)] [&>h2]:font-[family-name:var(--font-heading)] [&>h2]:text-2xl [&>h3]:text-[var(--color-secondary)] [&>p]:text-[var(--color-text)] [&>a]:text-[var(--color-primary)] hover:[&>a]:text-[var(--color-primary-dark)]"
            />
          </div>

        </div>
      </section>

      {/* Custom Keyframe Animations Style block */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
    </>
  );
}

export default TermsofServices;
